<template>
  <div>
    <div class="underline">
      <slot name="underline"></slot>
    </div>
    <under-label><slot></slot></under-label>
  </div>
</template>
<script>
import UnderLabel from "./_UnderLabel.vue";

export default {
  name: "shared-under-text",
  components: {
    UnderLabel
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.underline {
  border-bottom: solid 1px $gray-200;
  font-size: 1.25em;
  font-weight: bold;
  line-height: 1.35em;
  min-height: 1.4em;
  color: $gray-600;
}
.header {
  color: $gray-400;
  font-family: "Francois One", sans-serif;
  font-size: 1.25em;
  line-height: 1em;
  margin-bottom: 0;
  min-width: 2.85em !important;
}
label {
  cursor: auto;
  font-size: 0.75em;
  font-weight: bold;
  margin-bottom: 0.25em;
}
</style>
